import { ActionTypes } from "../constants";

export default function bse(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_BSE:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}